// BUILD-046 task 8.20: React binding for the My Work host's Caller summary (hostMeController.ts holds the logic and its tests).
//
// One controller per host. It loads `GET /work/me` on mount and again whenever the Caller changes (the pilot persona switcher, the pilot Reset,
// or another tab switching the server-held persona), and it keeps the FAILURE (phase `error`) so the host can fall back to the legacy page. It
// never reloads the page and never retries on its own.
import { useEffect, useRef, useSyncExternalStore } from 'react';
import { onCallerChanged, workApi } from '../../api/workShared';
import { createHostMeController } from './hostMeController';
import type { HostMeController, HostMeState } from './hostMeController';

export function useHostMe(): HostMeState {
  const ref = useRef<HostMeController | null>(null);
  if (ref.current === null) ref.current = createHostMeController({ getEpoch: () => workApi.getCallerEpoch(), getMe: () => workApi.getMe() });
  const controller = ref.current;
  const state = useSyncExternalStore(controller.subscribe, controller.getState);
  useEffect(() => {
    void controller.load();
    return onCallerChanged(() => {
      void controller.callerChanged();
    });
  }, [controller]);
  return state;
}
